import React from 'react';
import { ENVIRONMENT } from 'config';

const StagingBanner = () => {
  if (ENVIRONMENT !== "staging") return null;

  return (
    <div
      style={{
        position: "fixed",
        bottom: 0,
        left: 0,
        width: "100%",
        height: 28,
        backgroundColor: "#ff9800",
        color: "#fff",
        fontWeight: "bold",
        fontSize: 12,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 9999,
        pointerEvents: "none",
      }}
    >
      ⚠ STAGING ENVIRONMENT
    </div>
  );
};

export default StagingBanner;
